/**
 * Counters.
 */
export default function headerSection() {
  document.querySelectorAll('.module--module-counters').forEach(module => {

    // how many frames per count up
    const speed = 200, speedmod = .4;

    // get all the counter spans
    let counters = [], modi = 1;
    module.querySelectorAll('span').forEach(span => {
      counters.push({
        element: span,
        number: Number(span.innerHTML),
        increment: Number(span.innerHTML) / (speed * modi),
        current: 0,
      });
      modi += speedmod;
    });

    // run them counters
    const runCounters = () => {
      const printNumber = number => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      counters.forEach(counter => {
        counter.element.innerHTML = '0';
        counter.interval = setInterval(() => {
          
          counter.current = counter.current += counter.increment;

          if (counter.current > counter.number) {

            // stop
            counter.current = 0;
            counter.element.innerHTML = printNumber(counter.number);
            clearInterval(counter.interval);
          } else {

            // increment
            counter.element.innerHTML = printNumber(Math.floor(counter.current));
          }
        }, 1000/speed);
      });
    }

    // listen for scroll reveal if the containing context is a revealer, otherwise just run
    if (module.parentNode.getAttribute('data-sw-reveal')) {
      module.parentNode.addEventListener('revealed', runCounters);
    } else {
      runCounters();
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/counters.js